// Danh mục bài viết — khớp vocab backend Post::CATEGORIES và miniapp news.ts
export const ARTICLE_CATEGORIES = [
  { value: "promotion", label: "Khuyến mãi" },
  { value: "product", label: "Sản phẩm" },
  { value: "event", label: "Sự kiện" },
];

// Danh mục là LOẠI, không phải trạng thái -> cùng một tone xám, phân biệt bằng chữ.
export const CATEGORY_META = {
  promotion: { label: "Khuyến mãi" },
  product: { label: "Sản phẩm" },
  event: { label: "Sự kiện" },
};
